module.exports = __webpack_public_path__ + "static/media/veneto-village-19.4158fb98.jpg";